import { MantineProvider, createTheme } from '@mantine/core';
import '@mantine/core/styles.css';
import { MedplumClient } from '@medplum/core';
import { MedplumProvider } from '@medplum/react';
import '@medplum/react/styles.css';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { App } from './App';

// Create a custom Medplum client that ignores certain paths
const medplum = new MedplumClient({
  onUnauthenticated: () => {
    if (!window.location.pathname.startsWith('/annotate')) {
      window.location.href = '/';
    }
  },
  baseUrl: 'https://cdr.copilothealth.com/',
  cacheTime: 60000,
  autoBatchTime: 100,
  clientId: '01961b96-216b-701f-a1df-463a500fe554',
  // Add a custom request middleware to ignore certain paths
  fetch: async (url: string, options?: RequestInit) => {
    // If the URL includes /annotate, don't make the request
    if (url.includes('/annotate')) {
      return new Response(null, { status: 204 });
    }
    // Otherwise, proceed with the normal fetch
    return fetch(url, options);
  }
});

const theme = createTheme({
  headings: {
    sizes: {
      h1: {
        fontSize: '1.125rem',
        fontWeight: '500',
        lineHeight: '2.0',
      },
    },
  },
  fontSizes: {
    xs: '0.6875rem',
    sm: '0.875rem',
    md: '0.875rem',
    lg: '1.0rem',
    xl: '1.125rem',
  },
});

const router = createBrowserRouter([{ path: '*', element: <App /> }]);

const navigate = (path: string): Promise<void> => router.navigate(path);

const container = document.getElementById('root') as HTMLDivElement;
const root = createRoot(container);

root.render(
  <StrictMode>
    <MedplumProvider medplum={medplum} navigate={navigate}>
      <MantineProvider theme={theme}>
        <Notifications position="bottom-right" />
        <RouterProvider router={router} />
      </MantineProvider>
    </MedplumProvider>
  </StrictMode>
);